<template>
  <div class="detailContainer">
    <el-timeline>
      <el-timeline-item
        v-for="(item, index) in tableData" :key="index" :timestamp="item.operationTime"
        placement="top"
      >
        <el-card>
          <el-form :model="item" class="operationData">
            <!--操作ip-->
            <el-form-item
              prop="ip"
              :label="$t('basicData.OperationalIP') + '：'"
            >
              <div>{{ item.operationIp }}</div>
            </el-form-item>
            <!--操作人姓名-->
            <el-form-item
              prop="operatorName"
              :label="$t('basicData.OperatorName') + '：'"
            >
              <div>{{ item.operatorName }}</div>
            </el-form-item>
            <!--操作时间-->
            <el-form-item
              prop="createTime"
              :label="$t('basicData.OperationTime') + '：'"
            >
              <div>{{ item.operationTime }}</div>
            </el-form-item>
            <!--操作内容-->
            <el-form-item
              prop="changeRemark"
              :label="$t('basicData.ActionContent') + '：'"
            >
              <div v-for="(list, ind) in item.changeRemark.split('\n')" :key="ind">
                {{ list }}
                <!--                <span-->
                <!--                  v-if="item.extra && ind === (item.changeRemark.split('\n').length - 1)"-->
                <!--                  style="color: #00A551;cursor: pointer;"-->
                <!--                  @click="downloadQuote(item.extra)"-->
                <!--                >{{ $t('basicData.DownloadTheQuote') }}</span>-->
              </div>
            </el-form-item>
          </el-form>
        </el-card>
      </el-timeline-item>
    </el-timeline>
  </div>
</template>

<script>
import { apiContractLogGetPage } from '@/api/finance/contractLedger';

export default {
  name: 'OperationLog',

  props: {
    // 合同详情
    rows: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      tableData: []
    };
  },

  created() {
    this.getLogTable();
  },
  methods: {
    // 获取操作日志
    getLogTable() {
      const dateData = (property, bol) => {
        return function(a, b) {
          const value1 = a[property];
          const value2 = b[property];
          if (bol) {
            // 升序
            return Date.parse(value1) - Date.parse(value2);
          } else {
            // 降序
            return Date.parse(value2) - Date.parse(value1);
          }
        };
      };
      apiContractLogGetPage(this.rows.id).then(res => {
        if (res.code === 200) {
          res.data.map(item => {
            item.operationTime = item.operationTime.replace(/[TZ]/g, ' ');
          });
          res.data.sort(dateData('operationTime', false));
          this.tableData = res.data;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.detailContainer {
  height: calc(100vh - 40px);
  overflow-y: auto;
  padding: 20px;
}
.el-timeline{
  padding: 0;
}
.el-form-item{
  margin-bottom: 0;
}
.operationData .el-form-item__label,
.operationData .el-form-item__content{
  line-height: 26px!important;
}
</style>
